import { defineMessages } from 'react-intl';

export default defineMessages({
  activationTitle: {
    id: 'activationTitle',
    description: 'Thank you for submitting your activation request',
    defaultMessage: 'Thank you for submitting your activation request',
  },
  activationDescription: {
    id: 'activationDescription',
    description: 'Red Hat will be in touch within 1 business day to confirm your subscription benefits are ready to be activated.',
    defaultMessage: 'Red Hat will be in touch within 1 business day to confirm your subscription benefits are ready to be activated.',
  },
  segmentError: {
    id: 'segmentError',
    description: 'Context used outside of its Provider!',
    defaultMessage: 'Context used outside of its Provider!',
  },
  changesComing: {
    id: 'changesComing',
    description: 'Changes are coming to cloud.redhat.com on July 29.',
    defaultMessage: 'Changes are coming to cloud.redhat.com on July 29.',
  },
  learnMore: {
    id: 'learnMore',
    description: 'Learn more on our blog.',
    defaultMessage: 'Learn more on our blog.',
  },
  viewChanged: {
    id: 'viewChanged',
    description: 'View has changed',
    defaultMessage: 'View has changed',
  },
  viewAsCustomer: {
    id: 'viewAsCustomer',
    description: 'You are now viewing console.redhat.com as a customer, and will be interacting with real customer data.',
    defaultMessage: 'You are now viewing console.redhat.com as a customer, and will be interacting with real customer data.',
  },
  newRequestReview: {
    id: 'newRequestReview',
    description: 'You have a new access request that needs your review',
    defaultMessage: 'You have a new access request that needs your review',
  },
  noLongerHaveAccess: {
    id: 'noLongerHaveAccess',
    description: `You no longer have access to account {accountId}.`,
    defaultMessage: `You no longer have access to account {accountId}.`,
  },
  somethingWentWrong: {
    id: 'somethingWentWrong',
    description: 'Something went wrong',
    defaultMessage: 'Something went wrong',
  },
  globalRuntimeErrorId: {
    id: 'globalRuntimeErrorId',
    description: 'Global runtime error Id',
    defaultMessage: 'Sentry error ID: {errorId}',
  },
  problemProcessingRequest: {
    id: 'problemProcessingRequest',
    description: 'There was a problem processing the request. Try reloading the page. If the problem persists, contact',
    defaultMessage: 'There was a problem processing the request. Try reloading the page. If the problem persists, contact',
  },
  redHatSupport: {
    id: 'redHatSupport',
    description: 'Red Hat support',
    defaultMessage: 'Red Hat support',
  },
  checkOur: {
    id: 'checkOur',
    description: 'or check our',
    defaultMessage: 'or check our',
  },
  statusPage: {
    id: 'statusPage',
    description: 'Status page',
    defaultMessage: 'Status page',
  },
  helpPanel: {
    id: 'helpPanel',
    description: 'Help panel',
    defaultMessage: 'Help panel',
  },
  helpPanelTooltip: {
    id: 'helpPanelTooltip',
    description: 'Help panel tooltip describing available resources',
    defaultMessage: 'Learning resources, API documentation, Support Case Management, Ask Red Hat assistant, and more.',
  },
  knownOutages: {
    id: 'knownOutages',
    description: 'for known outages.',
    defaultMessage: 'for known outages.',
  },
  returnToHomepage: {
    id: 'returnToHomepage',
    description: 'Return to home page',
    defaultMessage: 'Return to home page',
  },
  shareYourFeedback: {
    id: 'shareYourFeedback',
    description: 'Share your feedback with us!',
    defaultMessage: 'Share your feedback with us!',
  },
  enterFeedback: {
    id: 'enterFeedback',
    description: 'Enter your feedback: Do not include any personal information or other sensitive information.',
    defaultMessage: 'Enter your feedback: Do not include any personal information or other sensitive information.',
  },
  researchOpportunities: {
    id: 'researchOpportunities',
    description: 'Yes, I would like to hear about research opportunities',
    defaultMessage: 'Yes, I would like to hear about research opportunities',
  },
  learnAboutResearchOpportunities: {
    id: 'learnAboutResearchOpportunities',
    description: 'Learn about opportunities to share your feedback with our User Research Team.',
    defaultMessage: 'Learn about opportunities to share your feedback with our User Research Team.',
  },
  weNeverSharePersonalInformation: {
    id: 'weNeverSharePersonalInformation',
    description: 'We never share your personal information, and you can opt out at any time.',
    defaultMessage: 'We never share your personal information, and you can opt out at any time.',
  },
  email: {
    id: 'email',
    description: 'Email',
    defaultMessage: 'Email',
  },
  submitFeedback: {
    id: 'submitFeedback',
    description: 'Submit feedback',
    defaultMessage: 'Submit feedback',
  },
  cancel: {
    id: 'cancel',
    description: 'Cancel',
    defaultMessage: 'Cancel',
  },
  feedback: {
    id: 'feedback',
    description: 'Feedback',
    defaultMessage: 'Feedback',
  },
  tellAboutExperience: {
    id: 'tellAboutExperience',
    description: 'Tell us about your experience',
    defaultMessage: 'Tell us about your experience',
  },
  helpUsImproveHCC: {
    id: 'helpUsImproveHCC',
    description: 'Help us improve the Red Hat Hybrid Cloud Console.',
    defaultMessage: 'Help us improve the Red Hat Hybrid Cloud Console.',
  },
  shareFeedback: {
    id: 'shareFeedback',
    description: 'Share feedback',
    defaultMessage: 'Share feedback',
  },
  howIsConsoleExperience: {
    id: 'howIsConsoleExperience',
    description: 'What has your console experience been like so far?',
    defaultMessage: 'What has your console experience been like so far?',
  },
  reportBug: {
    id: 'reportBug',
    description: 'Report a bug',
    defaultMessage: 'Report a bug',
  },
  describeBug: {
    id: 'describeBug',
    description: 'Describe the bug you encountered. For urgent issues, open a support case instead.',
    defaultMessage: 'Describe the bug you encountered. For urgent issues, open a support case instead.',
  },
  openSupportCase: {
    id: 'openSupportCase',
    description: 'Open a support case ',
    defaultMessage: 'Open a support case ',
  },
  getSupport: {
    id: 'getSupport',
    description: 'Get help from Red Hat support.',
    defaultMessage: 'Get help from Red Hat support.',
  },
  submitOnlyInStageProd: {
    id: 'submitOnlyInStageProd',
    description: 'Submitting feedback only works in prod and stage',
    defaultMessage: 'Submitting feedback only works in prod and stage',
  },
  feedbackSent: {
    id: 'feedbackSent',
    description: 'Feedback Sent',
    defaultMessage: 'Feedback Sent',
  },
  thankYouForFeedback: {
    id: 'thankYouForFeedback',
    description: 'Thank you, we appreciate your feedback.',
    defaultMessage: 'Thank you, we appreciate your feedback.',
  },
  close: {
    id: 'close',
    description: 'Close',
    defaultMessage: 'Close',
  },
  showMore: {
    id: 'showMore',
    description: 'Show more',
    defaultMessage: 'Show more',
  },
  resetFilters: {
    id: 'resetFilters',
    description: 'Reset filters',
    defaultMessage: 'Reset filters',
  },
  noInventoryPermissions: {
    id: 'noInventoryPermissions',
    description: 'You do not have the required inventory permissions to perform this action',
    defaultMessage: 'You do not have the required inventory permissions to perform this action',
  },
  globalFilterNotApplicable: {
    id: 'globalFilterNotApplicable',
    description: 'Global filter is not applicable for this page',
    defaultMessage: 'Global filter is not applicable for this page',
  },
  filterResults: {
    id: 'filterResults',
    description: 'Filter results',
    defaultMessage: 'Filter results',
  },
  selectTagsOrSIDs: {
    id: 'selectTagsOrSIDs',
    description: 'Select one or more tags',
    defaultMessage: 'Select one or more tags',
  },
  name: {
    id: 'name',
    description: 'Name',
    defaultMessage: 'Name',
  },
  value: {
    id: 'value',
    description: 'Value',
    defaultMessage: 'Value',
  },
  tagSources: {
    id: 'tagSources',
    description: 'Tag sources',
    defaultMessage: 'Tag sources',
  },
  tagsFilter: {
    id: 'tagsFilter',
    description: 'Tags filter',
    defaultMessage: 'Tags filter',
  },
  filterTags: {
    id: 'filterTags',
    description: 'Filter tags',
    defaultMessage: 'Filter tags',
  },
  SIDsFilter: {
    id: 'SIDsFilter',
    description: 'SIDs Filter',
    defaultMessage: 'SIDs Filter',
  },
  filterSAPIDs: {
    id: 'filterSAPIDs',
    description: 'Filter SAP IDs',
    defaultMessage: 'Filter SAP IDs',
  },
  findAppOrService: {
    id: 'findAppOrService',
    description: 'Find a service',
    defaultMessage: 'Find a service',
  },
  noMatchingAppsFound: {
    id: 'noMatchingAppsFound',
    description: 'No matching applications or services found.',
    defaultMessage: 'No matching applications or services found.',
  },
  tryChangingSearch: {
    id: 'tryChangingSearch',
    description: 'This filter criteria matches no applications or services. Try changing your input filter.',
    defaultMessage: 'This filter criteria matches no applications or services. Try changing your input filter.',
  },
  personalAccount: {
    id: 'personalAccount',
    description: 'Personal account',
    defaultMessage: 'Personal account',
  },
  noResults: {
    id: 'noResults',
    description: 'No results',
    defaultMessage: 'No results',
  },
  searchAccount: {
    id: 'searchAccount',
    description: 'Search account',
    defaultMessage: 'Search account',
  },
  login: {
    id: 'login',
    description: 'Log in',
    defaultMessage: 'Log in',
  },
  stopUsing: {
    id: 'stopUsing',
    description: 'Stop using',
    defaultMessage: 'Stop using',
  },
  use: {
    id: 'use',
    description: 'Use',
    defaultMessage: 'Use',
  },
  betaRelease: {
    id: 'betaRelease',
    description: 'the preview release',
    defaultMessage: 'the preview release',
  },
  supportOptions: {
    id: 'supportOptions',
    description: 'Support options',
    defaultMessage: 'Support options',
  },
  apiDocumentation: {
    id: 'apiDocumentation',
    description: 'API documentation',
    defaultMessage: 'API documentation',
  },
  insightsRhelDocumentation: {
    id: 'insightsRhelDocumentation',
    description: 'Insights for RHEL Documentation',
    defaultMessage: 'Insights for RHEL Documentation',
  },
  demoMode: {
    id: 'demoMode',
    description: 'Demo mode',
    defaultMessage: 'Demo mode',
  },
  globalLearningResourcesPage: {
    id: 'globalLearningResourcesPage',
    description: 'All learning resources',
    defaultMessage: 'All learning resources',
  },
  loggedOut: {
    id: 'loggedOut',
    description: 'You have successfully logged out.',
    defaultMessage: 'You have successfully logged out.',
  },
  useAccountNumber: {
    id: 'useAccountNumber',
    description:
      "Use this number when contacting Red Hat for support. If you've never had a subscription in your account, you may not see an account number here.",
    defaultMessage:
      "Use this number when contacting Red Hat for support. If you've never had a subscription in your account, you may not see an account number here.",
  },
  accountNumber: {
    id: 'accountNumber',
    description: 'Account number:',
    defaultMessage: 'Account number:',
  },
  orgId: {
    id: 'orgId',
    description: 'Org ID:',
    defaultMessage: 'Org ID:',
  },
  orgAdministrator: {
    id: 'orgAdministrator',
    description: 'Org. Administrator',
    defaultMessage: 'Org. Administrator',
  },
  internalUser: {
    id: 'internalUser',
    description: 'Internal user',
    defaultMessage: 'Internal user',
  },
  myProfile: { id: 'myProfile', description: 'My profile', defaultMessage: 'My profile' },
  myUserAccess: { id: 'myUserAccess', description: 'My User Access', defaultMessage: 'My User Access' },
  userPreferences: {
    id: 'userPreferences',
    description: 'User Preferences',
    defaultMessage: 'User Preferences',
  },
  internal: {
    id: 'internal',
    description: 'Internal',
    defaultMessage: 'Internal',
  },
  logout: {
    id: 'logout',
    description: 'Log out',
    defaultMessage: 'Log out',
  },
  home: {
    id: 'home',
    description: 'Home',
    defaultMessage: 'Home',
  },
  viewingAsAccount: {
    id: 'viewingAsAccount',
    description: 'Viewing as Account {selectedAccountNumber}',
    defaultMessage: 'Viewing as Account {selectedAccountNumber}',
  },
  viewRequest: {
    id: 'viewRequest',
    description: 'View request',
    defaultMessage: 'View request',
  },
  username: {
    id: 'username',
    description: 'Username:',
    defaultMessage: 'Username:',
  },
  authFailure: {
    id: 'authFailure',
    description: 'Authorization failure',
    defaultMessage: 'Authorization failure',
  },
  accessRestricted: {
    id: 'accessRestricted',
    description: 'Access to this page is reserved for third party IDP token from users on authorized accounts.',
    defaultMessage: 'Access to this page is reserved for third party IDP token from users on authorized accounts.',
  },
  tryUsingDifferentAccount: {
    id: 'tryUsingDifferentAccount',
    description: 'Try using different account',
    defaultMessage: 'Try using different account',
  },
  quickStarts: {
    id: 'quickStarts',
    description: 'Quick starts',
    defaultMessage: 'Quick starts',
  },
  learnHowTo: {
    id: 'learnHowTo',
    description: 'Learn how to create, import, and run applications with step-by-step instructions and tasks.',
    defaultMessage: 'Learn how to create, import, and run applications with step-by-step instructions and tasks.',
  },
  unableToLoadQuickstartsContent: {
    id: 'unableToLoadQuickstartsContent',
    description: 'Unable to load the quickstarts content.',
    defaultMessage: 'Unable to load the quickstarts content.',
  },
  thereWillBeACatalgPage: {
    id: 'thereWillBeACatalgPage',
    description: 'There will be a catalog page for {bundle} bundle',
    defaultMessage: 'There will be a catalog page for {bundle} bundle',
  },
  tryThisFeatureInBeta: {
    id: 'tryThisFeatureInBeta',
    description:
      'Try this feature in our Preview Environment on console.redhat.com/preview. The Preview Environment allows you to interact with new features in an active development space. Because preview pre-release software is still being developed, you may encounter bugs or flaws in availability, stability, data, or performance.',
    defaultMessage:
      'Try this feature in our Preview Environment on console.redhat.com/preview. The Preview Environment allows you to interact with new features in an active development space. Because preview pre-release software is still being developed, you may encounter bugs or flaws in availability, stability, data, or performance.',
  },
  afterBetaUse: {
    id: 'afterBetaUse',
    description:
      'After you use a feature in preview, you’ll stay in the Preview Environment until you manually exit the preview release. Leave the Preview Environment any time by clicking on the settings (gear) icon or preview icon in the top toolbar.',
    defaultMessage:
      'After you use a feature in preview, you’ll stay in the Preview Environment until you manually exit the preview release. Leave the Preview Environment any time by clicking on the settings (gear) icon or preview icon in the top toolbar.',
  },
  useFeatureInBeta: {
    id: 'useFeatureInBeta',
    description: 'Use feature in preview',
    defaultMessage: 'Use feature in preview',
  },
  learnMoreABoutBeta: {
    id: 'learnMoreABoutBeta',
    description: 'Learn more about Preview Environment',
    defaultMessage: 'Learn more about Preview Environment',
  },
  permissionErrorDescription: {
    id: 'permissionErrorDescription',
    defaultMessage:
      'Contact your organization administrator(s) for more information or visit <MuaLink>My User Access</MuaLink> to learn more about your permissions.',
  },
  permissionErrorDetail: {
    id: 'permissionErrorDetail',
    defaultMessage: 'Detail: {message}.',
  },
  filterByTags: {
    id: 'filterByTags',
    description: 'Placeholder to indicate ',
    defaultMessage: 'Filter by tags',
  },
  filterByTagsPopoverHeader: {
    id: 'filterByTagsPopoverHeader',
    description: 'Popover Header',
    defaultMessage: 'Tags',
  },
  filterByTagsPopoverCCGLink: {
    id: 'filterByTagsPopoverCCGLink',
    description: 'Client Configuration Guide link',
    defaultMessage: 'Client Configuration Guide',
  },
  filterByTagsPopoverSatelliteLink: {
    id: 'filterByTagsPopoverSatelliteLink',
    description: 'Installing the Satellite inventory upload plugin link',
    defaultMessage: 'imported',
  },
  filterByTagsPopoverContent1: {
    id: 'filterByTagsPopoverContent1',
    description: 'Popover Help Content',
    defaultMessage:
      'Tagging can be used to classify further and organize your hosts shown within the Insights inventory. If connected to a Satellite, tags from that Satellite can be',
  },
  filterByTagsPopoverContent2: {
    id: 'filterByTagsPopoverContent2',
    description: 'Popover Help Content',
    defaultMessage: '. Additionally, you can define your own tags via the Insights-Client configuration. Please see our',
  },
  filterByTagsPopoverContent3: {
    id: 'filterByTagsPopoverContent3',
    description: 'Popover Help Content',
    defaultMessage: 'for more details. Please note that Workload tags are automatically added by the Insights service.',
  },
  reportABug: {
    id: 'reportABug',
    description: 'Report a bug',
    defaultMessage: 'Report a bug',
  },
  describeReportBug: {
    id: 'describeReportBug',
    description: 'Describe the bug you encountered. Include where it is located and what action caused it. If this issue is urgent or blocking your workflow, ',
    defaultMessage:
      'Describe the bug you encountered. Include where it is located and what action caused it. If this issue is urgent or blocking your workflow, ',
  },
  describeBugUrgentCases: {
    id: 'describeBugUrgentCases',
    description: 'Describe the bug you encountered. For urgent issues, open a support case instead.',
    defaultMessage: 'Describe the bug you encountered. For urgent issues, open a support case instead.',
  },
  addDescription: {
    id: 'addDescription',
    description: 'Add description',
    defaultMessage: 'Add description',
  },
  back: {
    id: 'back',
    description: 'Back',
    defaultMessage: 'Back',
  },
  informRedhatDirection: {
    id: 'informRedhatDirection',
    description: 'Inform the direction of Red Hat',
    defaultMessage: 'Inform the direction of Red Hat',
  },
  informDirectionDescription: {
    id: 'informDirectionDescription',
    description: 'By participating in feedback sessions, usability tests, and interviews with our ',
    defaultMessage: 'By participating in feedback sessions, usability tests, and interviews with our ',
  },
  userResearchTeam: {
    id: 'userResearchTeam',
    description: 'User Research Team',
    defaultMessage: 'User Research Team',
  },
  directInfluence: {
    id: 'directInfluence',
    description:
      ', your feedback will directly influence the future of Red Hat’s products. Opt in below to hear about future research opportunities via email.',
    defaultMessage:
      ', your feedback will directly influence the future of Red Hat’s products. Opt in below to hear about future research opportunities via email.',
  },
  bugReported: {
    id: 'bugReported',
    description: 'Bug Reported',
    defaultMessage: 'Bug Reported',
  },
  teamWillReviewBug: {
    id: 'teamWillReviewBug',
    description: 'We appreciate your feedback and our team will review your report shortly',
    defaultMessage: 'We appreciate your feedback and our team will review your report shortly',
  },
  responseSent: {
    id: 'responseSent',
    description: 'Response sent',
    defaultMessage: 'Response sent',
  },
  thankYouForInterest: {
    id: 'thankYouForInterest',
    description: 'Thank you for your interest in user research. You have been added to our mailing list.',
    defaultMessage: 'Thank you for your interest in user research. You have been added to our mailing list.',
  },
  joinMailingList: {
    id: 'joinMailingList',
    description: 'Join mailing list',
    defaultMessage: 'Join mailing list',
  },
  askRedHat: {
    id: 'askRedHat',
    description: 'Ask Red Hat',
    defaultMessage: 'Ask Red Hat',
  },
});
